export default __webpack_public_path__ + "static/media/bg21.05f9a503.jpg";